import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import {CheckCircle} from 'lucide-react'

function Home() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-bege-fundo flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl w-full text-center"
      >
        <div className="inline-block bg-verde-claro text-white px-4 py-2 rounded-full text-sm font-dm-sans font-medium mb-6">
          Diagnóstico Personalizado
        </div>

        <h1 className="text-5xl md:text-6xl font-cormorant font-semibold text-texto-escuro mb-6">
          Diagnóstico de Saúde e Emoções
        </h1>

        <p className="text-lg text-texto-suave mb-12 leading-relaxed">
          Descubra quais óleos essenciais o seu corpo e mente precisam.<br />Responda com sinceridade.<br />Cada pergunta revela um caminho.
        </p>

        <div className="space-y-4 mb-12">
          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-verde-claro flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
            <p className="text-texto-escuro">20 perguntas sobre saúde física e emocional</p>
          </div>

          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-verde-claro flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
            <p className="text-texto-escuro">Resultado personalizado ao final</p>
          </div>

          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-verde-claro flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
            <p className="text-texto-escuro">Leva cerca de 5 minutos</p>
          </div>
        </div>

        <button
          onClick={() => navigate('/resultado')}
          className="bg-verde-escuro text-white px-8 py-4 rounded-full text-lg font-dm-sans font-medium hover:bg-opacity-90 transition-all shadow-lg hover:shadow-xl"
        >
          Começar meu diagnóstico →
        </button>
      </motion.div>
    </div>
  )
}

export default Home
